import { render, staticRenderFns } from "./SupersessionLine.vue?vue&type=template&id=b07d9c96&scoped=true"
import script from "./SupersessionLine.vue?vue&type=script&lang=js"
export * from "./SupersessionLine.vue?vue&type=script&lang=js"
import style0 from "./SupersessionLine.vue?vue&type=style&index=0&id=b07d9c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07d9c96",
  null
  
)

export default component.exports